import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectMassiveSignStatus = createSelector(
  [(store: RootState) => store.documentsSignerList.massiveSignStatus],
  (value) => value
);
